import { createElement, Fragment } from 'react';
import { getWalletIconUrl } from '../helpers/getWalletIconUrl.js';
import { findWalletBookWallet } from '../helpers/findWalletBookWallet.js';
import '../helpers/logger.js';
import '../schemas/walletConnectSourceSchema.js';
import '../schemas/walletBookSchema.js';
import '../schemas/walletSchema.js';
import { useWalletBookContext } from '../hooks/useWalletBookContext.js';

const WalletIcon = ({ walletName, children, ...props }) => {
    const { walletBook } = useWalletBookContext();
    const walletData = findWalletBookWallet(walletBook, walletName);
    const walletIconUrl = getWalletIconUrl(walletBook, walletName);
    if (!walletData || !walletData.brand || !walletIconUrl) {
        return createElement(Fragment, {}, children);
    }
    return createElement('img', {
        'data-testid': `wallet-icon-${walletName}`,
        ...props,
        alt: walletData.brand.alt,
        src: walletIconUrl,
    }, children);
};

export { WalletIcon };
